import { useState } from "react";

// Сертифікати ключа: здебільшого підвантажуються автоматично з ЦСК — поле сховане під «+», відкривається за потреби
export default function CertField({ onChange, disabled }) {
  const [open, setOpen] = useState(false);
  if (!open) return <p className="field cert-toggle"><button type="button" className="link-btn" disabled={disabled} onClick={() => setOpen(true)}>+ Сертифікати .cer</button><span className="field-hint">лише якщо ключ без них не відкривається</span></p>;
  return <label className="field">Сертифікати <span className="field-hint">.cer, якщо ключ без них не відкривається</span><input type="file" accept=".cer,.crt" multiple disabled={disabled} onChange={(e) => onChange([...e.target.files])} /></label>;
}
